import { render, staticRenderFns } from "./StandardTable.vue?vue&type=template&id=ad0c4cb4&scoped=true&"
import script from "./StandardTable.vue?vue&type=script&lang=js&"
export * from "./StandardTable.vue?vue&type=script&lang=js&"
import style0 from "./StandardTable.vue?vue&type=style&index=0&id=ad0c4cb4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad0c4cb4",
  null
  
)

export default component.exports